<!-- <canvas #canvas width="{{width}}" height="{{height}}"></canvas> -->
<canvas #canvas></canvas>
<!-- <p><button (click)="animate()"></button></p> -->